import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function EdunetLanding() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      sessionStorage.setItem("edunet_new_login_flow", "true");
      navigate("/auth", { replace: true });
    }, 2200);

    return () => {
      clearTimeout(timer);
    };
  }, [navigate]);

  return (
    <div className="edunet-splash">

      {/* =====================================================
          CINEMATIC BACKGROUND
      ===================================================== */}

      <div className="ambient ambient-blue"></div>
      <div className="ambient ambient-purple"></div>
      <div className="ambient ambient-cyan"></div>

      <div className="cinematic-vignette"></div>

      {/* =====================================================
          CENTER
      ===================================================== */}

      <div className="edunet-center">

        {/* =================================================
            EDUNET LOGO
        ================================================= */}

        <div className="edunet-logo-wrap">
          <div className="edunet-logo">
            <span>E</span>
            <span>D</span>
            <span>U</span>
            <span>N</span>
            <span>E</span>
            <span>T</span>
          </div>
        </div>

        {/* =================================================
            NETFLIX STYLE LOADING SPINNER
        ================================================= */}

        <div className="loading-spinner">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* =================================================
            FINAL LIGHT
        ================================================= */}

        <div className="final-flash"></div>

      </div>

      {/* =====================================================
          STYLE
      ===================================================== */}

      <style>{`

        /* =====================================================
           MAIN SPLASH
        ===================================================== */

        .edunet-splash {
          position: fixed;
          inset: 0;
          width: 100%;
          height: 100vh;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          background:
            radial-gradient(
              circle at 50% 48%,
              #172b55 0%,
              #0d1933 24%,
              #070d1c 48%,
              #02050b 75%,
              #000000 100%
            );
          z-index: 999999;
          isolation: isolate;
        }

        /* =====================================================
           CENTER
        ===================================================== */

        .edunet-center {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 5;
          perspective: 1200px;
          overflow: visible;
        }

        /* =====================================================
           CINEMATIC VIGNETTE
        ===================================================== */

        .cinematic-vignette {
          position: absolute;
          inset: 0;
          z-index: 2;
          pointer-events: none;
          background:
            radial-gradient(
              ellipse at center,
              transparent 20%,
              rgba(0,0,0,0.15) 50%,
              rgba(0,0,0,0.72) 100%
            );
        }

        /* =====================================================
           AMBIENT LIGHTS
        ===================================================== */

        .ambient {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
          filter: blur(35px);
          opacity: 0;
        }

        .ambient-blue {
          width: 420px;
          height: 420px;
          left: -100px;
          top: 5%;
          background: rgba(0,105,255,0.24);
          animation: blueAmbient 1.8s ease-out forwards;
        }

        .ambient-purple {
          width: 400px;
          height: 400px;
          right: -100px;
          bottom: -50px;
          background: rgba(120,40,255,0.22);
          animation: purpleAmbient 1.8s ease-out forwards;
        }

        .ambient-cyan {
          width: 280px;
          height: 280px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background: rgba(0,180,255,0.13);
          animation: cyanAmbient 1.8s ease-out forwards;
        }

        /* =====================================================
           EDUNET LOGO
        ===================================================== */

        .edunet-logo-wrap {
          position: absolute;
          inset: 0;
          z-index: 10;
          width: 100%;
          height: 100%;
          pointer-events: none;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: visible;
        }

        .edunet-logo {
          position: absolute;
          left: 50%;
          top: 50%;
          width: max-content;
          height: max-content;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Arial, Helvetica, sans-serif;
          font-size: clamp(58px, 9vw, 125px);
          font-weight: 900;
          letter-spacing: 7px;
          white-space: nowrap;
          opacity: 0;
          transform:
            translate3d(-50%, -50%, 0)
            scale(0.05);
          will-change: transform, opacity;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          animation:
            edunetOneLayer
            1.6s
            cubic-bezier(0.22, 0.61, 0.36, 1)
            forwards;
        }

        /* =====================================================
           LOGO LETTERS
        ===================================================== */

        .edunet-logo span {
          display: inline-block;
          background:
            linear-gradient(
              135deg,
              #ffffff 0%,
              #d9ecff 24%,
              #54aaff 58%,
              #1769d1 100%
            );
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          text-shadow:
            0 0 10px
            rgba(80,160,255,0.22);
        }

        /* =====================================================
           LOADING SPINNER
        ===================================================== */

        .loading-spinner {
          position: absolute;
          z-index: 30;
          left: 50%;
          top: calc(50% + 92px);
          width: 32px;
          height: 32px;
          transform:
            translate3d(-50%, 0, 0)
            scale(0.65);
          opacity: 0;
          will-change: transform, opacity;
          backface-visibility: hidden;
          animation:
            spinnerAppear
            4s
            linear
            forwards,
            spinnerRotate
            0.7s
            linear
            2.4s
            infinite;
        }

        /* =====================================================
           SPINNER DOTS
        ===================================================== */

        .loading-spinner span {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 4px;
          height: 9px;
          margin-left: -2px;
          margin-top: -4.5px;
          border-radius: 50%;
          background: rgba(255,255,255,0.18);
          transform-origin: 2px 20px;
        }

        .loading-spinner span:nth-child(1) {
          transform: rotate(0deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(2) {
          transform: rotate(30deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(3) {
          transform: rotate(60deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(4) {
          transform: rotate(90deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(5) {
          transform: rotate(120deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(6) {
          transform: rotate(150deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(7) {
          transform: rotate(180deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(8) {
          transform: rotate(210deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(9) {
          transform: rotate(240deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(10) {
          transform: rotate(270deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(11) {
          transform: rotate(300deg) translateY(-12px);
        }

        .loading-spinner span:nth-child(12) {
          transform: rotate(330deg) translateY(-12px);
        }

        /* =====================================================
           FINAL LIGHT
        ===================================================== */

        .final-flash {
          position: absolute;
          will-change: transform, opacity;
          backface-visibility: hidden;
          z-index: 40;
          width: 30px;
          height: 30px;
          left: 50%;
          top: 50%;
          transform:
            translate(-50%, -50%)
            scale(0);
          border-radius: 50%;
          background: rgba(255,255,255,0.95);
          box-shadow:
            0 0 40px
            rgba(120,190,255,0.9),
            0 0 100px
            rgba(80,130,255,0.7);
          opacity: 0;
          pointer-events: none;
          animation:
            finalFlash
            2s
            ease-out
            forwards;
        }

        /* =====================================================
           EDUNET MAIN ANIMATION
        ===================================================== */

        @keyframes edunetOneLayer {

          0% {
            opacity: 0;
            transform:
              translate3d(-50%, -50%, 0)
              scale(0.05);
          }

          18% {
            opacity: 0.18;
            transform:
              translate3d(-50%, -50%, 0)
              scale(0.16);
          }

          36% {
            opacity: 0.42;
            transform:
              translate3d(-50%, -50%, 0)
              scale(0.36);
          }

          52% {
            opacity: 0.72;
            transform:
              translate3d(-50%, -50%, 0)
              scale(0.62);
          }

          65% {
            opacity: 1;
            transform:
              translate3d(-50%, -50%, 0)
              scale(0.86);
          }

          72% {
            opacity: 1;
            transform:
              translate3d(-50%, -50%, 0)
              scale(1);
          }

          82% {
            opacity: 1;
            transform:
              translate3d(-50%, -50%, 0)
              scale(1);
          }

          88% {
            opacity: 0.98;
            transform:
              translate3d(-50%, -50%, 0)
              scale(1.03);
          }

          94% {
            opacity: 0.75;
            transform:
              translate3d(-50%, -50%, 0)
              scale(1.12);
          }

          98% {
            opacity: 0.30;
            transform:
              translate3d(-50%, -50%, 0)
              scale(1.28);
          }

          100% {
            opacity: 0;
            transform:
              translate3d(-50%, -50%, 0)
              scale(1.44);
          }
        }

        /* =====================================================
           SPINNER APPEAR
        ===================================================== */

        @keyframes spinnerAppear {

          0% {
            opacity: 0;
            transform:
              translateX(-50%)
              scale(0.45);
          }

          62% {
            opacity: 0;
            transform:
              translateX(-50%)
              scale(0.45);
          }

          67% {
            opacity: 0.55;
            transform:
              translateX(-50%)
              scale(0.8);
          }

          70% {
            opacity: 0.95;
            transform:
              translateX(-50%)
              scale(1);
          }

          78% {
            opacity: 0.9;
            transform:
              translateX(-50%)
              scale(1);
          }

          83% {
            opacity: 0;
            transform:
              translateX(-50%)
              scale(1.08);
          }

          100% {
            opacity: 0;
            transform:
              translateX(-50%)
              scale(1.1);
          }
        }

        /* =====================================================
           SPINNER ROTATION
        ===================================================== */

        @keyframes spinnerRotate {
          0% {
            rotate: 0deg;
          }

          100% {
            rotate: 360deg;
          }
        }

        /* =====================================================
           FINAL FLASH
        ===================================================== */

        @keyframes finalFlash {

          0% {
            opacity: 0;
            transform:
              translate(-50%, -50%)
              scale(0);
          }

          82% {
            opacity: 0;
            transform:
              translate(-50%, -50%)
              scale(0);
          }

          92% {
            opacity: 0.12;
            transform:
              translate(-50%, -50%)
              scale(3);
          }

          97% {
            opacity: 0.05;
            transform:
              translate(-50%, -50%)
              scale(12);
          }

          100% {
            opacity: 0;
            transform:
              translate(-50%, -50%)
              scale(20);
          }
        }

        /* =====================================================
           BLUE AMBIENT
        ===================================================== */

        @keyframes blueAmbient {

          0% {
            opacity: 0;
            transform: scale(0.45);
          }

          35% {
            opacity: 0.7;
          }

          70% {
            opacity: 0.42;
            transform: scale(1);
          }

          100% {
            opacity: 0;
            transform: scale(1.25);
          }
        }

        /* =====================================================
           PURPLE AMBIENT
        ===================================================== */

        @keyframes purpleAmbient {

          0% {
            opacity: 0;
            transform: scale(0.4);
          }

          40% {
            opacity: 0.62;
          }

          72% {
            opacity: 0.35;
            transform: scale(1);
          }

          100% {
            opacity: 0;
            transform: scale(1.3);
          }
        }

        /* =====================================================
           CYAN AMBIENT
        ===================================================== */

        @keyframes cyanAmbient {

          0% {
            opacity: 0;
            transform:
              translate(-50%, -50%)
              scale(0.2);
          }

          40% {
            opacity: 0.8;
            transform:
              translate(-50%, -50%)
              scale(0.8);
          }

          70% {
            opacity: 0.35;
            transform:
              translate(-50%, -50%)
              scale(1.15);
          }

          100% {
            opacity: 0;
            transform:
              translate(-50%, -50%)
              scale(1.5);
          }
        }

        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 600px) {

          .edunet-logo {
            font-size: 52px;
            letter-spacing: 4px;
          }

          .loading-spinner {
            top: calc(50% + 68px);
            width: 28px;
            height: 28px;
          }

          .loading-spinner span {
            transform-origin: 2px 17px;
          }
        }

        /* =====================================================
           REDUCED MOTION
        ===================================================== */

        @media (prefers-reduced-motion: reduce) {

          .edunet-logo {
            animation: none;
            opacity: 1;
            transform:
              translate3d(-50%, -50%, 0)
              scale(1);
          }

          .loading-spinner,
          .final-flash,
          .ambient {
            animation: none;
            opacity: 0;
          }
        }

      `}</style>

    </div>
  );
}

export default EdunetLanding;